import { CDNAudioAddress } from '../models/constants'

const audioFiles = {
  onesecond: `${CDNAudioAddress}/onesecond.mp3`,
  speechrecognition: `${CDNAudioAddress}/blip.mp3`
}

export { audioFiles }
